import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import { GlobalNavProvider } from '../../../../state';
import desktopStyles from '../../../DesktopNav/DesktopNav.module.scss';
import mobileStyles from '../../../MobileNav/MobileNav.module.scss';
import { GlobalNavProps } from '../../../types';
import ResultsPageSearchBar from './ResultsPageSearchBar';
import searchBarStyles from './SearchBar.module.scss';

import '../../../DesktopNav/ResultsPageSearchBar.scss';

//TODO: Search Page Hierarchy experiment cleanup EB-228109
/*!IMPORTANT: If the experiment is a success, we will likely need to keep this
standalone component until GlobalNav is updated for both logged in and logged out states */
const SearchBarStandalone: React.FC<GlobalNavProps> = ({
    positionSticky,
    searchBar,
    logo,
    navigation,
    user,
    env,
}) => {
    const desktopClass = classNames(
        positionSticky?.desktop ? 'desktopSticky' : '',
        'searchPageSearchBarOverride',
    );

    const mobileClass = classNames(
        positionSticky?.mobile ? 'mobileSticky' : '',
        searchBarStyles.mobileComponent,
    );

    return (
        <GlobalNavProvider
            positionSticky={positionSticky}
            searchBar={searchBar}
            logo={logo}
            user={user}
            env={env}
            navigation={navigation}
        >
            <nav
                aria-label={gettext('Main Desktop').toString()}
                data-testid="desktop-nav"
                className={desktopClass}
            >
                <ul className={desktopStyles.list}>
                    <div className={'searchPageSearchBar'}>
                        <ResultsPageSearchBar />
                    </div>
                </ul>
            </nav>
            <nav
                aria-label={gettext('Main Mobile').toString()}
                data-testid="mobile-nav"
                className={mobileClass}
            >
                <ul className={mobileStyles.root}>
                    <li className={mobileStyles.searchBar}>
                        <ResultsPageSearchBar />
                    </li>
                </ul>
            </nav>
        </GlobalNavProvider>
    );
};

export default SearchBarStandalone;
